<template>
  <div style="background: #f8fafc; min-height: 100vh; font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
    <!-- Hero Section -->
    <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 80px 0;">
      <div class="container text-center">
        <div style="max-width: 800px; margin: 0 auto;">
          <h1 style="font-size: 3rem; font-weight: 800; margin-bottom: 24px; letter-spacing: -1px;">Transparent Pricing</h1>
          <p style="font-size: 1.2rem; opacity: 0.95; line-height: 1.7;">Flexible pricing models designed to fit your project needs and budget. Whether you need a one-time consultation or ongoing partnership, we've got you covered.</p>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="container" style="max-width: 1100px; margin-top: -40px;">
      <div class="row">
        <div class="col-md-12">
          <div class="service-main-card">
            
            <!-- Pricing Philosophy -->
            <div style="text-align: center; margin-bottom: 50px;">
              <h2 style="color: #1a202c; font-weight: 700; font-size: 2.2rem; margin-bottom: 20px;">Simple, Fair, Transparent</h2>
              <p style="color: #4a5568; font-size: 1.1rem; line-height: 1.7; max-width: 700px; margin: 0 auto;">No hidden fees. No surprises. Just honest pricing based on the complexity of your project and the value we deliver.</p>
            </div>

            <!-- Standard Hourly Rates -->
            <div style="background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%); padding: 40px; border-radius: 16px; margin-bottom: 40px; border-left: 4px solid #3b82f6;">
              <h3 style="color: #1a202c; font-weight: 700; margin-bottom: 24px; font-size: 1.8rem; text-align: center;">Standard Hourly Rates</h3>
              
              <div class="row">
                <div class="col-md-6 mb-4">
                  <div style="background: white; padding: 30px; border-radius: 12px; height: 100%; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
                    <h4 style="color: #3b82f6; font-weight: 700; margin-bottom: 16px; font-size: 1.4rem;">Consultation & Advisory</h4>
                    <div style="font-size: 2.5rem; font-weight: 800; color: #1a202c; margin-bottom: 8px;">$225<span style="font-size: 1.2rem; font-weight: 400; color: #6b7280;">/hr</span></div>
                    <p style="color: #4a5568; margin-bottom: 20px; line-height: 1.6;">Architecture reviews, technical consulting, strategic planning, and expert guidance.</p>
                    <ul style="color: #4a5568; line-height: 1.8; margin: 0; padding-left: 20px;">
                      <li>AWS architecture design and review</li>
                      <li>Technical strategy sessions</li>
                      <li>Performance optimization planning</li>
                      <li>Security audits and recommendations</li>
                      <li>Migration planning and assessment</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-6 mb-4">
                  <div style="background: white; padding: 30px; border-radius: 12px; height: 100%; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
                    <h4 style="color: #3b82f6; font-weight: 700; margin-bottom: 16px; font-size: 1.4rem;">Implementation & Development</h4>
                    <div style="font-size: 2.5rem; font-weight: 800; color: #1a202c; margin-bottom: 8px;">$225<span style="font-size: 1.2rem; font-weight: 400; color: #6b7280;">/hr</span></div>
                    <p style="color: #4a5568; margin-bottom: 20px; line-height: 1.6;">Hands-on development, infrastructure deployment, API design, and technical implementation.</p>
                    <ul style="color: #4a5568; line-height: 1.8; margin: 0; padding-left: 20px;">
                      <li>Infrastructure as Code development</li>
                      <li>API design and implementation</li>
                      <li>Database design and optimization</li>
                      <li>Application development</li>
                      <li>DevOps pipeline setup</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Retainer & Volume Discounts -->
            <div style="background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%); padding: 40px; border-radius: 16px; margin-bottom: 40px; border-left: 4px solid #f59e0b;">
              <h3 style="color: #92400e; font-weight: 700; margin-bottom: 20px; font-size: 1.8rem; text-align: center;">Save with Retainers & Volume Discounts</h3>
              
              <div style="background: rgba(255,255,255,0.6); padding: 24px; border-radius: 12px; margin-bottom: 30px;">
                <h4 style="color: #92400e; font-weight: 600; margin-bottom: 12px; font-size: 1.2rem; text-align: center;">Why Such Steep Discounts?</h4>
                <p style="color: #78350f; margin-bottom: 12px; line-height: 1.7; text-align: center; font-size: 1.05rem;">
                  Let's be honest: ramp-up time, context switching, and scheduling uncertainty are tough when projects are small and sporadic. Our standard hourly rate reflects that overhead. When you commit to guaranteed hours, it eliminates the unknowns—we can plan better, work more efficiently, and stay focused on your project.
                </p>
                <p style="color: #78350f; margin: 0; line-height: 1.7; text-align: center; font-size: 1.05rem;">
                  <strong>We pass those savings directly to you.</strong>
                </p>
              </div>
              
              <div class="row">
                <div class="col-md-4 mb-3">
                  <div style="background: white; padding: 24px; border-radius: 12px; height: 100%; text-align: center;">
                    <div style="font-size: 3rem; font-weight: 800; color: #f59e0b; margin-bottom: 8px;">10-20%</div>
                    <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px; font-size: 1.2rem;">Monthly Retainer</h4>
                    <p style="color: #4a5568; margin: 0; line-height: 1.6;">Commit to 10+ hours per month and save on your hourly rate.</p>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <div style="background: white; padding: 24px; border-radius: 12px; height: 100%; text-align: center;">
                    <div style="font-size: 3rem; font-weight: 800; color: #f59e0b; margin-bottom: 8px;">15-30%</div>
                    <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px; font-size: 1.2rem;">Larger Projects</h4>
                    <p style="color: #4a5568; margin: 0; line-height: 1.6;">Projects over 100 hours receive volume discounts based on scope.</p>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <div style="background: white; padding: 24px; border-radius: 12px; height: 100%; text-align: center;">
                    <div style="font-size: 3rem; font-weight: 800; color: #f59e0b; margin-bottom: 8px;">20-40%</div>
                    <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px; font-size: 1.2rem;">Ongoing Partnership</h4>
                    <p style="color: #4a5568; margin: 0; line-height: 1.6;">Long-term maintenance and development retainers offer the best rates.</p>
                  </div>
                </div>
              </div>

              <div style="background: rgba(255,255,255,0.7); padding: 20px; border-radius: 10px; margin-top: 24px; text-align: center;">
                <p style="color: #78350f; margin: 0; line-height: 1.7; font-size: 1.05rem;">
                  <strong>Looking for ongoing support?</strong> Check out our specialized retainer packages for 
                  <NuxtLink to="/services/platform-maintenance" style="color: #f59e0b; text-decoration: underline; font-weight: 600;">Platform Maintenance</NuxtLink> and 
                  <NuxtLink to="/services/development-services" style="color: #f59e0b; text-decoration: underline; font-weight: 600;">Development Services</NuxtLink>.
                </p>
              </div>
            </div>

            <!-- Project-Based Pricing -->
            <div style="background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%); padding: 40px; border-radius: 16px; margin-bottom: 40px; border-left: 4px solid #8b5cf6;">
              <h3 style="color: #1a202c; font-weight: 700; margin-bottom: 20px; font-size: 1.8rem;">Fixed-Price Projects</h3>
              <p style="color: #4a5568; margin-bottom: 30px; line-height: 1.7; font-size: 1.1rem;">Prefer a fixed price? We offer project-based pricing for well-defined scopes.</p>
              
              <div class="row">
                <div class="col-md-6 mb-3">
                  <div style="background: white; padding: 24px; border-radius: 12px; height: 100%;">
                    <h4 style="color: #8b5cf6; font-weight: 600; margin-bottom: 12px; font-size: 1.2rem;">✅ What Works Well</h4>
                    <ul style="color: #4a5568; line-height: 1.8; margin: 0; padding-left: 20px;">
                      <li>Architecture assessments</li>
                      <li>Migration projects with clear scope</li>
                      <li>Specific feature implementations</li>
                      <li>Infrastructure audits</li>
                      <li>Performance optimization projects</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div style="background: white; padding: 24px; border-radius: 12px; height: 100%;">
                    <h4 style="color: #8b5cf6; font-weight: 600; margin-bottom: 12px; font-size: 1.2rem;">💡 How It Works</h4>
                    <ol style="color: #4a5568; line-height: 1.8; margin: 0; padding-left: 20px;">
                      <li>Discovery call to understand your needs</li>
                      <li>Detailed scope and requirements document</li>
                      <li>Fixed-price proposal with milestones</li>
                      <li>Execute with regular updates</li>
                      <li>Final delivery and knowledge transfer</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- What's Included -->
            <div style="background: white; padding: 40px; border-radius: 16px; margin-bottom: 40px; border: 2px solid #e5e7eb;">
              <h3 style="color: #1a202c; font-weight: 700; margin-bottom: 30px; font-size: 1.8rem; text-align: center;">What's Always Included</h3>
              
              <div class="row">
                <div class="col-md-3 col-sm-6 mb-4">
                  <div style="text-align: center;">
                    <div style="font-size: 2.5rem; margin-bottom: 12px;">📧</div>
                    <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 8px; font-size: 1.1rem;">Communication</h4>
                    <p style="color: #6b7280; margin: 0; font-size: 0.95rem;">Email and chat support included</p>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6 mb-4">
                  <div style="text-align: center;">
                    <div style="font-size: 2.5rem; margin-bottom: 12px;">📄</div>
                    <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 8px; font-size: 1.1rem;">Documentation</h4>
                    <p style="color: #6b7280; margin: 0; font-size: 0.95rem;">Clear docs for everything we build</p>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6 mb-4">
                  <div style="text-align: center;">
                    <div style="font-size: 2.5rem; margin-bottom: 12px;">🎓</div>
                    <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 8px; font-size: 1.1rem;">Knowledge Transfer</h4>
                    <p style="color: #6b7280; margin: 0; font-size: 0.95rem;">We'll teach you how it works</p>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6 mb-4">
                  <div style="text-align: center;">
                    <div style="font-size: 2.5rem; margin-bottom: 12px;">✅</div>
                    <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 8px; font-size: 1.1rem;">Best Practices</h4>
                    <p style="color: #6b7280; margin: 0; font-size: 0.95rem;">Production-ready, scalable solutions</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Factors That Affect Pricing -->
            <div style="background: #f8fafc; padding: 40px; border-radius: 16px; margin-bottom: 40px;">
              <h3 style="color: #1a202c; font-weight: 700; margin-bottom: 24px; font-size: 1.8rem;">Factors That Affect Pricing</h3>
              
              <div class="row">
                <div class="col-md-6 mb-3">
                  <h4 style="color: #3b82f6; font-weight: 600; margin-bottom: 12px; font-size: 1.1rem;">Project Complexity</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.7;">Simple configurations receive lower rates than complex, multi-region architectures with advanced features.</p>
                </div>
                <div class="col-md-6 mb-3">
                  <h4 style="color: #3b82f6; font-weight: 600; margin-bottom: 12px; font-size: 1.1rem;">Infrastructure Size</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.7;">Larger infrastructures with more services, environments, and components require more management time.</p>
                </div>
                <div class="col-md-6 mb-3">
                  <h4 style="color: #3b82f6; font-weight: 600; margin-bottom: 12px; font-size: 1.1rem;">Technical Debt</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.7;">Legacy systems or poorly documented infrastructure require additional discovery and refactoring time.</p>
                </div>
                <div class="col-md-6 mb-3">
                  <h4 style="color: #3b82f6; font-weight: 600; margin-bottom: 12px; font-size: 1.1rem;">Timeline Requirements</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.7;">Rush projects or tight deadlines may require premium rates to prioritize and deliver quickly.</p>
                </div>
              </div>
            </div>

            <!-- FAQ -->
            <div style="background: white; padding: 40px; border-radius: 16px; margin-bottom: 40px; border: 2px solid #e5e7eb;">
              <h3 style="color: #1a202c; font-weight: 700; margin-bottom: 30px; font-size: 1.8rem; text-align: center;">Frequently Asked Questions</h3>
              
              <div style="max-width: 800px; margin: 0 auto;">
                <div style="margin-bottom: 30px;">
                  <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px; font-size: 1.2rem;">Is the initial consultation free?</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.7;">Yes! We don't charge for the initial discovery call to discuss your project, understand your needs, and determine if we're a good fit. However, once we begin any meaningful work or assessment, we'll need a contract or purchase order in place before starting.</p>
                </div>
                
                <div style="margin-bottom: 30px;">
                  <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px; font-size: 1.2rem;">Do you have a minimum project size?</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.7;">For consultations and advisory work, there's no minimum—we're happy to help with focused sessions. For implementation projects, we typically have a 20-hour minimum to ensure we can deliver meaningful value. Retainer packages start at 10 hours per month.</p>
                </div>
                
                <div style="margin-bottom: 30px;">
                  <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px; font-size: 1.2rem;">How do you bill for work?</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.7;">We bill in 15-minute increments and provide detailed time tracking. For retainers, we bill monthly in advance. For project work, we typically bill at project milestones or monthly, whichever comes first.</p>
                </div>
                
                <div style="margin-bottom: 30px;">
                  <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px; font-size: 1.2rem;">Can I cancel or adjust my retainer?</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.7;">Yes! We require 30 days notice to cancel or adjust retainer packages. We want long-term partnerships, not locked-in contracts.</p>
                </div>
                
                <div style="margin-bottom: 30px;">
                  <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px; font-size: 1.2rem;">Do unused retainer hours roll over?</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.7;">Yes! Rollover policies vary by tier (1-3 months depending on your package), giving you flexibility in how you use your hours.</p>
                </div>
                
                <div style="margin-bottom: 0;">
                  <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px; font-size: 1.2rem;">What if my project scope changes?</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.7;">We're flexible! For fixed-price projects, we'll discuss scope changes and adjust accordingly. For hourly work, you have full control over priorities and can adjust as you go.</p>
                </div>
              </div>
            </div>

            <!-- CTA Section -->
            <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 50px 40px; border-radius: 16px; text-align: center;">
              <h3 style="font-weight: 700; margin-bottom: 20px; font-size: 2rem;">Ready to Get Started?</h3>
              <p style="font-size: 1.15rem; opacity: 0.95; line-height: 1.7; margin-bottom: 30px; max-width: 700px; margin-left: auto; margin-right: auto;">Let's discuss your project and find the pricing model that works best for your needs and budget. We'll provide a detailed proposal with transparent pricing and clear deliverables.</p>
              <p style="margin: 0; font-size: 1.1rem; opacity: 0.9;">Contact us for a free consultation and custom quote.</p>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
useHead({
  title: 'Pricing - Geek Cafe',
  meta: [
    { name: 'description', content: 'Transparent pricing for AWS consulting, development, and infrastructure services. Flexible hourly rates, retainer packages, and volume discounts available.' }
  ]
})
</script>

<style scoped src="@/assets/css/service-detail-card.css"></style>
